import Constants from "expo-constants";
import { Platform } from "react-native";

const { expoConfig } = Constants;
export const isStaging = true;
export const stagingBaseUrl = "https://staging-partners.memorang.app";
export const isDev = process.env.EXPO_PUBLIC_IS_DEV === "true";

export const PROD_HUB_BASE_URL = "https://hub.memorang.com";

// biome-ignore lint/correctness/noConstantCondition: <explanation>
export const baseNextjsUrl = false
	? Platform.OS === "android"
		? `http://${expoConfig!.hostUri?.split(":").shift()}:3000`
		: isStaging
			? "https://staging-hub.memorang.com"
			: "http://localhost:3000"
	: "https://staging-hub.memorang.com";

export const baseDevUrl =
	Platform.OS === "android"
		? `http://${expoConfig!.hostUri?.split(":").shift()}:8081`
		: isStaging
			? "https://staging-partners.memorang.app"
			: "http://localhost:8081";

export const ENDPOINT_GET_WAVEFORM_DATA = `${baseNextjsUrl}/api/ai/get-audio-waveform`;

export const ENDPOINT_TTS = `${baseNextjsUrl}/api/ai/tts`;

// Paths only; the session client (apiAxios) supplies the base URL.
export const API_ENDPOINTS = {
	SESSIONS: "/assessments/v1/sessions",
	SESSION_END: (sessionId: number) =>
		`/assessments/v1/sessions/${sessionId}/end`,
	SESSION_ITEMS: (sessionId: number) =>
		`/assessments/v1/sessions/${sessionId}/items`,
	SESSION_REPORTS: (sessionId: number) =>
		`/assessments/v1/sessions/${sessionId}/reports`,
	ANSWER_EVENTS: "/assessments/v1/responses/answer-events",
	USER_SESSIONS: (userId: number) => `/assessments/v1/users/${userId}/sessions`,
	ITEM_DISTRIBUTION: (userId: number) =>
		`/assessments/v1/users/${userId}/item-distribution`,
} as const;
